/**
 * Definición de rutas y navegación.
 *
 * Módulo de datos, sin JSX: así el test puede comprobar la forma de la
 * navegación sin montar React.
 *
 * EXACTAMENTE 5 destinos en la barra inferior. Ajustes va como engranaje en la
 * cabecera, fuera de la navegación.
 *
 * Razón concreta: con 6 o más aparece la tentación del menú «Más», un patrón
 * que ya costó dos bugs reales en otro proyecto —el desplegable recortado por
 * un `overflow` de la navegación, y el menú que se quedaba abierto al navegar—.
 * Con 5 y Ajustes arriba, el problema no existe.
 */

export interface DestinoNav {
  ruta: string;
  etiqueta: string;
  /** Nombre accesible, cuando la etiqueta corta no basta. */
  titulo: string;
}

/** Los cinco destinos de la barra inferior, en orden. */
export const DESTINOS_NAV: DestinoNav[] = [
  { ruta: '/', etiqueta: 'Hoy', titulo: 'Hoy' },
  { ruta: '/plan', etiqueta: 'Plan', titulo: 'Plan' },
  { ruta: '/banco', etiqueta: 'Banco', titulo: 'Learning Bank' },
  { ruta: '/progreso', etiqueta: 'Progreso', titulo: 'Progreso' },
  { ruta: '/herramientas', etiqueta: 'Herramientas', titulo: 'Herramientas' },
];

/** Ajustes existe como ruta, pero NO como pestaña. */
export const RUTA_AJUSTES = '/ajustes';

/**
 * El modo foco tiene su propia URL y vive FUERA del layout: sin barra de
 * navegación, sin estadísticas. Que sea una ruta y no un overlay es lo que hace
 * que recargar a mitad de sesión vuelva a la sesión, no a Hoy.
 */
export const RUTA_SESION = '/sesion';

/** Todas las rutas de la aplicación, para pruebas y para el fallback. */
export const TODAS_LAS_RUTAS = [
  ...DESTINOS_NAV.map((d) => d.ruta),
  RUTA_AJUSTES,
  RUTA_SESION,
];
